<template>
    <v-autocomplete
        :items="items || []"
        item-text="name"
        item-value="id"
        :value="value"
        :label="label || $t('attributes.card_type')"
        @input="$emit('input', $event)"
        :clearable="clearable"
        :outlined="outlined"
        :error-messages="errorMessages"
        :chips="chips"
        :return-object="false"
    ></v-autocomplete>
</template>
<script>
import { mapState } from "vuex";

export default {
    name: "CardTypesField",

    props: {
        value: [String, Number],
        label: { type: String },
        errorMessages: [String, Array],
        clearable: { type: Boolean, default: false },
        outlined: { type: Boolean, default: false },
        chips: { type: Boolean, default: false },
        exclude: [String, Number],
        client: [String, Number, Object]
    },

    computed: {
        ...mapState({
            data: state => state.cardType.items.data
        }),
        items() {
            return this.data;
        }
    },
    created() {
        if (!this.data || !this.data.data) this.$store.dispatch("cardType/fetchAll");
    }
};
</script>
